import React, {useState} from "react"
import {CelebrationTag, CelebrationTagKind} from "@irati/types"
import {Radio} from "@irati/ui/src/FormItem"
import CelebrationTagsQuery from "@irati/recognition/services/queries/CelebrationTags"
import {Query} from "@irati/utils/services/apollo"
import Validation from "@irati/utils/validation"
import {injectIntl, InjectIntlProps} from "@irati/utils/lang/injectIntl"

interface CelebrationTagsProps extends InjectIntlProps {
  onChange: (tag: CelebrationTag) => void
}
const parseTagsToRadio = (tags: CelebrationTag[]) => {
  return tags.map(({name}) => ({
    label: name,
    value: name
  }))
}
const CelebrationTags = (props: CelebrationTagsProps) => {
  const {onChange, formatMessage} = props
  const [selectedTag, setSelectedTag] = useState<CelebrationTag>()
  const onTagSelected = (tag: CelebrationTag) => {
    setSelectedTag(tag)
    onChange(tag)
  }
  return (
    <Query query={CelebrationTagsQuery} variables={{kind: CelebrationTagKind.Greeting}}>
      {({data: {celebrationTags}, loading}) => {
        const findMatchingTag = (tagName: string) => celebrationTags.find(({name}: CelebrationTag) => name === tagName)
        if (loading || !celebrationTags) {
          return null
        }
        return (
          <Radio
            name="celebrationTag"
            value={selectedTag?.name}
            inline
            justifyRadios="flex-start"
            validation={Validation.string(formatMessage({id: "platform.defaultValidation.required"})).test(
              "Recipient list cannot be empty",
              "platform.defaultValidation.required",
              () => !!selectedTag
            )}
            options={parseTagsToRadio(celebrationTags)}
            onChange={(tagValue) => onTagSelected(findMatchingTag(tagValue))}
          />
        )
      }}
    </Query>
  )
}

export default injectIntl(CelebrationTags)
